import { DataActionTypes, productsPageActionTypes } from "../actions/actiontypes";
import * as LocalStorage from "../../../utils/localStorage";
const intialState = {
    data:LocalStorage.getLSValue("productsData")||null,
    selectedProducts:[],
    showAddProductComponent:false,
    showProductDetailsComponent:false,
    showProduct:{},
    showAddCategory:false,
}
export const ProductsReducer = (state=intialState,action)=>{
    switch(action.type){
        case DataActionTypes.set_ProductsData:{
            return {...state,data:action.payload}
        }
        case productsPageActionTypes.set_Selected_Products:{
            return {...state,selectedProducts:action.payload}
        }
        case productsPageActionTypes.delete_Selected_Products:{
            return {...state,data:action.payload.data, selectedProducts:action.payload.selectedProducts}
        }
        case productsPageActionTypes.delete_Product_category:{
            return {...state,data:action.payload}
        }
        case productsPageActionTypes.on_Add_Product:{
            return {...state,showAddProductComponent:action.payload}
        }
        case productsPageActionTypes.Add_Product:{
            return {...state,data:action.payload}
        }
        case productsPageActionTypes.on_Show_Product:{
            return {...state,showProductDetailsComponent:action.payload.showDetailsComponent,showProduct:action.payload.showDetails}
        }
        case productsPageActionTypes.show_Add_Category:{
            return{...state,showAddCategory:action.payload}
        }
        case productsPageActionTypes.on_Add_Category:{
            return {...state,data:action.payload}
        }
        default:
            return state
    }
}